// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1749645594628
      var cssReload = require("/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  